import * as runtime from '@/api/runtime'

import {
  BatchStatisticsDailyOutputRequest,
  BatchStatisticsDailyOutputRequestToJSON
} from '@/api/models/batch/BatchStatisticsDailyOutputConditionListItem'

export class BatchStatisticsDailyOutputApi extends runtime.BaseAPI {
  /**
   * 統計実行
   * @param request
   */
  async createStatisticsDailyOutput(
    request: BatchStatisticsDailyOutputRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/daily-output`,
      BatchStatisticsDailyOutputRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
